module.exports = {
  defaultTitle: 'SparksDNA - Creates Values For You',
  logo: 'https://media.publit.io/file/icon-Z.png',
  videoIllustration1: 'https://www.sparksdna.com/video/motion.mp4',
  author: 'Sparks DNA',
  url: 'https://www.sparksdna.com/video/motion.mp4',
  legalName: 'Sparks DNA',
  defaultDescription: 'Sparks DNA - Creates Values For You',
  socialLinks: {
    // linkedin: 'https://www.linkedin.com/in/donnyhandoyo/'
  },
  googleAnalyticsID: 'UA-160615042-1',
  themeColor: '#6b63ff',
  backgroundColor: '#6b63ff',
  address: {
    city: 'Jakarta',
    region: 'Rawasari',
    country: 'Indonesia',
    zipCode: '10570',
  },
  contact: {
    email: 'info@sparksdna.com',
    phone: '085-234-168-800',
  },
  foundingDate: '2020',
  recaptcha_key: '6LdW2eYUAAAAAEfcLrbxk7u5NdqvrKjbgCiKyG3W',
  edges: [
    {
      id: 1,
      url: 'http://www.dalnetsystem.com/',
      type: 'website',
      name: 'DALnet Billing Management System ',
      description: 'Enhancement Billing System on DALnet',
      // image: 'https://media.publit.io/file/sparksdna.png',
      // imageLarge: [{ source: 'https://media.publit.io/file/sparksdna.png' }]
      image: 'https://media.publit.io/file/dalnet.png',
      imageLarge: [{ source: 'https://media.publit.io/file/dalnet_large.png' }]
    },
    {
      id: 2,
      url: 'http://integrainstitute.co.id/',
      type: 'website',
      name: 'Integra Institute (integrainstitute.co.id)',
      description: 'Custom CMS / Web Company Profile.',
      image: 'https://media.publit.io/file/integrainstitute.co.id__small.png',
      imageLarge: [{ source: 'https://media.publit.io/file/integrainstitute.co.id__large.opt.png' }]
    },
    {
      id: 3,
      url: 'http://atour.id/',
      type: 'website',
      name: 'Atour (atour.id)',
      description: 'Web Company Profile Tour Travel Atour.id',
      image: 'https://media.publit.io/file/atour.id__small.png',
      imageLarge: [{ source: 'https://media.publit.io/file/atour.id__large.opt.png' }]
    },
    {
      id: 4,
      url: 'http://bangku.id/',
      type: 'website',
      name: 'Bangku - Platform Pinjaman Usaha (bangku.id)',
      description: 'Revamp Web, Add Survey, Borrower Registration',
      image: 'https://media.publit.io/file/bangku_id_small.png',
      imageLarge: [{ source: 'https://media.publit.io/file/bangku_large.png' }]
    },
  ],
};
